<template>
  <div class="nav-breadcrumb">
    <el-breadcrumb separator="/">
      <template v-for="(item,index) in dataList">
        <el-breadcrumb-item v-if="item.routeName" :key="index" :to="{name:item.routeName,params:item.params?item.params:{},query:item.query?item.query:{}}">{{item.title}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else :key="index">{{item.title}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
    <slot name="rightbutton"></slot>
  </div>
</template>

<script>
  export default {
    name: "JuBreadcrumb",
    props:{
      list:{
        type:Array,
        default(){
          return []
        }
      }
    },
    data(){
      return {
        dataList:[]
      }
    },
    mounted() {
      this.generateBreadcrumb();
    },
    methods:{
      generateBreadcrumb(){
        const path = this.$route.meta.breadcrumb || [];
        let _list = [{title:'首页搜索',routeName:'home'}];

        _list = _list.concat(this.list);

        path.forEach(function (n) {
          if(typeof n === 'string'){
            _list.push({title:n});
          }else{
            _list.push({title:n[0],routeName:n[1]});
          }
        });
        _list.push({'title':this.$route.meta.title || '未命名'});
        this.dataList = _list;
      }
    },
    watch:{
      $route(){
        this.generateBreadcrumb();
      }
    }
  }
</script>

<style scoped lang="less">
.nav-breadcrumb{
  // ju-box ju-pl-4 ju-pr-4 ju-pt-5 ju-pb-5
  background: #fff;
  height: 54px;
  padding:9px 20px;
  line-height: 54px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500 !important;
  color: #333333;
  line-height: 24px;
  justify-content: space-between;
}
</style>